import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { auth } from '../../lib/supabase';
import { isAdminUser } from '../../utils/authRoles';

const AdminGuard = ({ children, fallback = null }) => {
  const location = useLocation();
  const { isAuthenticated, loading, user, profile } = useSelector((state) => state.auth);
  const hasAdminRole = isAdminUser(user, profile);
  const [mfaStatus, setMfaStatus] = useState('checking');

  useEffect(() => {
    if (!isAuthenticated || !hasAdminRole) {
      setMfaStatus('checking');
      return undefined;
    }

    let active = true;
    setMfaStatus('checking');

    auth.getMfaAssuranceLevel()
      .then(({ data, error }) => {
        if (!active) return;
        setMfaStatus(!error && data?.currentLevel === 'aal2' ? 'verified' : 'required');
      })
      .catch(() => {
        if (active) setMfaStatus('required');
      });

    return () => {
      active = false;
    };
  }, [hasAdminRole, isAuthenticated]);

  if (loading) {
    return fallback;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!hasAdminRole) {
    return <Navigate to="/" replace state={{ from: location, message: 'Admin access required' }} />;
  }

  if (mfaStatus === 'checking') {
    return fallback;
  }

  if (mfaStatus !== 'verified') {
    return <Navigate to="/admin-mfa" replace state={{ from: location }} />;
  }

  return children;
};

export default AdminGuard;
